(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-bbm-gallery]').forEach((gallery) => {
      if (gallery.dataset.galleryReady) return;
      const images = [...gallery.querySelectorAll('[data-gallery-image]')];
      const thumbnails = gallery.querySelector('[data-gallery-thumbnails]');
      const buttons = [...gallery.querySelectorAll('[data-gallery-select]')];
      const status = gallery.querySelector('[data-gallery-status]');
      if (!images.length) return;
      gallery.dataset.galleryReady = 'true';
      const show = (index) => {
        if (!Number.isInteger(index) || index < 0 || index >= images.length) return;
        images.forEach((image, position) => { image.hidden = position !== index; });
        buttons.forEach((button, position) => { button.setAttribute('aria-pressed', String(position === index)); });
        if (status) {
          status.textContent = gallery.dataset.imageLabel.replace('__CURRENT__', String(index + 1)).replace('__TOTAL__', String(images.length));
          status.hidden = false;
        }
      };
      buttons.forEach((button) => {
        button.addEventListener('click', () => show(Number(button.dataset.gallerySelect)));
      });
      if (thumbnails && images.length > 1) thumbnails.hidden = false;
      show(0);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
